<highcharts-chart
  class="block w-full min-h-[480px]"
  id="result-chart"
  [options]="chartOptions()"
  [oneToOne]="true"
  [constructorType]="'chart'"
  [update]="true"
/>
<div [ngClass]="isTableVisible() ? 'block' : 'hidden'">
  <mat-card
    appearance="outlined"
    class="max-h-[calc(100vh-100px)] overflow-y-scroll"
    id="data-table"
  >
    <mat-card-header>{{ 'RESULT.TABLE_VIEW' | translate }}</mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="tableData" matSort>
        <!-- Position Column -->
        <ng-container matColumnDef="tstamp">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'RESULT.CHART.TSTAMP' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.tstamp }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="actual">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'RESULT.CHART.REAL' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.actual | number: '1.0-2' }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="forecast">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'RESULT.CHART.PREDICTION' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.forecast | number: '1.0-2' }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="confidence_min">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'RESULT.CHART.CONFIDENCE_INTERVAL' | translate }} (min.)
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.confidence_min | number: '1.0-2' }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="confidence_max">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'RESULT.CHART.CONFIDENCE_INTERVAL' | translate }} (max.)
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.confidence_max | number: '1.0-2' }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedTableColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedTableColumns"></tr>
      </table>
    </mat-card-content>
  </mat-card>
</div>
